// Guía bajo cada juego: cómo se juega, clasificación, consejos y preguntas frecuentes.
// Ayuda al jugador nuevo y da a los buscadores texto sobre la página (sale de src/seo/pages.ts).
import { SEO_BY_PATH } from '../seo/pages';

export default function GameGuide({ path }: { path: string }) {
  const page = SEO_BY_PATH[path];
  if (!page) return null;
  return (
    <section aria-labelledby="guia" className="max-w-3xl mx-auto px-4 sm:px-6 pt-12 pb-20 border-t border-line/60">
      <h2 id="guia" className="text-title2 font-semibold text-ink">{page.h1}</h2>
      <p className="mt-2 text-body text-ink-2 text-pretty">{page.intro}</p>
      <div className="mt-8 grid sm:grid-cols-2 gap-x-10 gap-y-8">
        {page.sections.map((s) => (
          <div key={s.heading}>
            <h3 className="text-title3 font-semibold text-ink">{s.heading}</h3>
            {s.paragraphs?.map((t) => <p key={t} className="mt-2 text-footnote text-ink-2 text-pretty">{t}</p>)}
            {s.list && (
              <ul className="mt-2 flex flex-col gap-1.5 list-disc pl-5 marker:text-ink-3">
                {s.list.map((t) => <li key={t} className="text-footnote text-ink-2 text-pretty">{t}</li>)}
              </ul>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
